const localization = {
    cannot_delete_default_language: '{{languageTag}} est défini comme votre langue par défaut et ne peut pas être supprimé.',
    invalid_translation_structure: 'Schémas de données invalides. Veuillez vérifier votre entrée et réessayer.',
};
export default localization;
